var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSemilogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 196,
    height: 300,
    viewBox: "0 0 196 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M250.617 -12H83.806C-27.8657 -9.31589 -28.0049 141.122 83.806 143.551H167.212C175.705 143.551 182.528 137.288 182.528 129.491C182.528 121.694 175.705 115.431 167.212 115.431H83.806C54.0083 115.559 29.5018 93.1917 29.641 65.7115C29.641 38.2313 54.0083 15.9915 83.806 15.9915H250.617C270.668 15.608 270.807 -11.4887 250.617 -12Z",
    fill: "#7F51FF",
    fillOpacity: 0.15
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M169.991 50.3568C168.449 50.22 167.047 50.22 165.645 50.22H81.6668C61.3382 50.7672 61.3382 79.767 81.6668 80.3142H165.645C167.327 80.3142 169.01 80.451 170.692 80.5878C198.872 83.05 220.182 105.894 220.182 133.663C220.182 163.073 195.647 186.875 165.645 186.875H88.6766C56.992 186.875 31.3359 212.044 31.3359 242.823C28.532 289.195 100.453 318.742 104.098 283.723C104.098 275.379 97.2287 268.676 88.6766 268.676C73.9559 268.676 62.0391 257.049 62.0391 242.686C62.0391 228.323 73.9559 216.695 88.6766 216.695H165.645C275.42 214.37 279.485 58.0172 169.991 50.3568Z",
    fill: "#7F51FF",
    fillOpacity: 0.15
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSemilogo);
export default __webpack_public_path__ + "static/media/semilogo.a8f4b54622ec753761014dd8f5732dae.svg";
export { ForwardRef as ReactComponent };